import { type OperationContext, type OperationResult, useMutation } from "urql"

import type { Mutation, PriceChangeMutationAddSpecialPricePackageArgs } from "@/graphql/codegen/graphql"
import { AddSpecialPriceMutationDocument } from "@/graphql/codegen/graphql"

interface UsePriceChangeReturn {
  addSpecialPricePackage: (
    variables: PriceChangeMutationAddSpecialPricePackageArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "priceChange">, PriceChangeMutationAddSpecialPricePackageArgs>>
}

export const usePriceChange = (): UsePriceChangeReturn => {
  const [, addSpecialPricePackage] = useMutation<
    Pick<Mutation, "priceChange">,
    PriceChangeMutationAddSpecialPricePackageArgs
  >(AddSpecialPriceMutationDocument)

  return {
    addSpecialPricePackage,
  }
}
